var Message = function(form) {

    var comp = $('[data-component="message"]');
    var $self = form;

    this.init = function() {

        mask();

        this.validate();

        this.active();
    }

    function mask() {
        comp.find('#phone').mask('(00) 00000-0000');
    }

    this.validate = function() {
        
       $($self).validate({
            ignore: ".ignore",
            rules:{
                name:{
                    required: true
                },
                email:{
                    required: true,
                    email: true
                },
                message: {
                    required: true
                },
                opcoes: {
                    required: true
                },
                hiddenRecaptcha: {
                    required: function () {
                        if (grecaptcha.getResponse() == '') {
                            return true;
                        } 
                        else {
                            return false;
                        }
                    }
                }
            },
            errorPlacement: function(error, element){},
            submitHandler: function(form) {

                if($(form).valid()) {

                    $(form).find("button").attr("disabled", true);

                    var MessageComponent = $($self).data("id");

                    var MessageData = {
                        "Name": $($self).find("input[name='name']").val(),
                        "Email": $($self).find("input[name='email']").val(),
                        "Telephone": $($self).find("input[name='phone']").val(),
                        "Company": $($self).find("input[name='company']").val(),
                        "IsCustomer": $($self).find("input[name='opcoes']:checked").val(),
                        "Message": $($self).find("textarea[name='message']").val()
                    }

                    //Exibir uma loading gif?

                    $.ajax({
                        type: "POST",
                        url: "/umbraco/surface/Message/Send",
                        data: JSON.stringify({ "MessageData": MessageData, "MessageComponent": MessageComponent, "response": grecaptcha.getResponse() }),
                        dataType: "json",
                        async: true,
                        contentType: "application/json; charset=utf-8",
                        success: function (response) {

                            //resetar os campos ou apresentar mensagem de sucesso ou fazer animacao de formulario enviado
                            //esconder a loading gif
                            $('[data-component="modal-form"] .text').text('Mensagem enviada!');
                            $(form).find('a.hidden')[0].click();
                            $(form).trigger("reset");
                            grecaptcha.reset();
                            $(form).find("button").attr("disabled", false);

                        },
                        error: function (e) {

                            //se for necessário: exibir uma mensagem de erro personalizada
                            //esconder a loading gif
                            $('[data-component="modal-form"] .text').text('Erro ao enviar a mensagem!');
                            $(form).find('a.hidden')[0].click();
                            $(form).find("button").attr("disabled", false);
                        }
                    });                    
                }
            }
        });
    }

    this.active = function() {

        $('.form-box input').on('focus', function(){
            TweenMax.to($(this).parent().find('.label-form'), .5, {scale: .8, top: -10 + 'px', transformOrigin: "left", ease: Back.easeOut});
        });

        $('.form-box input').on('focusout', function(){
            if($(this).val() == ''){
                TweenMax.to($(this).parent().find('.label-form'), .5, {scale: 1, top: 0 + 'px', ease: Back.easeOut});
            };
        });


        
    }

    return this.init();
}